module.exports = __webpack_public_path__ + "static/media/sms-signup.61bbec26.png";